import {deviceDetect,} from 'react-device-detect';
import {sendMixpanelProperties} from '../dataFetchers/analyticsDataTracker';
import { setRefValues } from './URLHelper';

let mixpanelSuperProperties = {};
export function setMixpanelSuperProperties () {
    let userDeviceDetails = deviceDetect();
    mixpanelSuperProperties["os"] = userDeviceDetails.osName;
    mixpanelSuperProperties["browser"] = userDeviceDetails.browserName;
    mixpanelSuperProperties["browser_version"] = userDeviceDetails.browserMajorVersion;
    // mixpanelSuperProperties["device"] = userDeviceDetails.osName; // to be decided.
    mixpanelSuperProperties["screen_height"] = window.screen.height;
    mixpanelSuperProperties["screen_width"] = window.screen.width;
    mixpanelSuperProperties["loginless"] = true;
}

export function trackEvent(uuid , eventName , properties, props) {
    let finalPayload = {};
    let refValues = props ? setRefValues(props) : {};
    finalPayload = {...mixpanelSuperProperties , ...properties , ...refValues};
    sendMixpanelProperties(uuid, eventName , finalPayload);
}
